<template>
  <div>
      <h5>LTI Settings</h5>
      <div v-if="!classToEdit">
        Invalid class
      </div>
      <div v-else-if="!classToEdit.ltiConsumerKey">
        <b-btn v-if="isOwnerOrAdmin" @click="createLTIData()">
          Create LTI Data (will refresh the page - any other unsaved changes will be lost)
        </b-btn>
      </div>
      <div v-else>
        <p>
          <i>
            Note: These settings only affect the initial setup process for an LTI course.
            Changes to this will not affect existing LTI configurations.
          </i>
        </p>
        <checkbox-input
          :disabled="isProfessor && !isOwnerOrAdmin"
          v-model="classToEdit.canvasAssignmentSectionPlacement"
        >
          Show in Assignment Section
        </checkbox-input>
        <checkbox-input
          :disabled="isProfessor && !isOwnerOrAdmin"
          v-model="classToEdit.canvasCourseNavigation"
        >
          Show in Course Navigation
        </checkbox-input>

        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Course Navigation Bar Text</b-input-group-text>
          </b-input-group-prepend>
          <b-input
              :disabled="isProfessor && !isOwnerOrAdmin"
              v-if="classToEdit.canvasCourseNavigation"
              v-model.trim="classToEdit.ltiNavButtonText"
              placeholder="Course Navigation Bar Text (defaults to Gamulation title)"
          />
        </b-input-group>
        <template v-if="isProfessor">
          <b-btn block @click="$refs.modal.show()">View LTI Setup Info</b-btn>
          <b-modal ref="modal" centered title="LTI Configuration Info" hide-footer size="xl">
            <class-lti-info-modal :classToEdit="classToEdit" />
          </b-modal>
        </template>
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClassLtiInfoModal from './ClassLtiInfoModal';
import TextInput from '../../../ui/inputs/TextInput';
import CheckboxInput from '../../../ui/inputs/CheckboxInput';

export default {
  components: { ClassLtiInfoModal, CheckboxInput, TextInput },
  props: {
    classToEdit: Object
  },
  methods: {
    ...mapGetters(['isProfessor', 'isOwnerOrAdmin']),
    ...mapActions(['initializeLtiDataForClass']),
    refresh() {
      // this.$emit('refresh-class');
      this.$router.go(0);
    },

    async createLTIData() {
      try {
        await this.initializeLtiDataForClass(this.classToEdit._id);
        this.refresh();
      } catch (err) {
        console.error(err);
        // eslint-disable-next-line no-alert
        alert(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/ClassLTIManager.vue